export function roleCheck (roles) {
	var defaultRoles = roles?.filter(item => item.role[0]?.isDefault && item.roleType !== 'NURSE')
	if(defaultRoles?.length === 0){
		defaultRoles = roles
	}
	const isSuperAdmin = defaultRoles?.find((item) => item.role && item.role[0]?.roleLevel === null && item.roleType !== 'NURSE');
	if (isSuperAdmin) {
		return isSuperAdmin;
	}
	const isAdmin = defaultRoles?.find((item) => item.role && item.role[0]?.roleLevel === 'ADMIN' && item.roleType !== 'NURSE');
	if (isAdmin) {
		return isAdmin;
	}
	const isManager = defaultRoles?.find((item) => item.role && item.role[0]?.roleLevel === 'MANAGER' && item.roleType !== 'NURSE');
	if (isManager) {
		return isManager;
	}
	return null;
	// const isSuperAdmin = roles?.find((item) => !item?.trustId && !item?.careLocationId);
	// if (isSuperAdmin) {
	// 	return isSuperAdmin;
	// }
	// const isTrustAdmin = roles?.find((item) => item?.trustId && !item?.careLocationId);
	// if (isTrustAdmin) {
	// 	return isTrustAdmin;
	// }
	// const isManager = roles?.find((item) => item?.trustId && item?.careLocationId);
	// if (isManager) {
	//   return isManager;
	// }
	// return null;
}
export function roleType (roles) {
	// const isSuperAdmin = roles?.find((item) => !item?.trustId && !item?.careLocationId);
	// if (isSuperAdmin) {
	// 	return { role: 'SUPER-ADMIN' };
	// }
	// const isTrustAdmin = roles?.find((item) => item?.trustId && !item?.careLocationId);
	// if (isTrustAdmin) {
	// 	return { role: 'TRUST-ADMIN' };
	// }
	// const isManager = roles?.find((item) => item?.trustId && item?.careLocationId);
	// if (isManager) {
	// 	return { role: 'MANAGER' };
	// }
	// return null;
	const isSuperAdmin = roles?.find((item) => item.role && item.role[0]?.roleLevel === null && item.roleType !== 'NURSE');
	if (isSuperAdmin) {
		return { role: 'SUPER-ADMIN' };
	}
	const isAdmin = roles?.find((item) => item.role && item.role[0]?.roleLevel === 'ADMIN' && item.roleType !== 'NURSE');
	if (isAdmin) {
		return { role: 'ADMIN' };
	}
	const isManager = roles?.find((item) => item.role && item.role[0]?.roleLevel === 'MANAGER' && item.roleType !== 'NURSE');
	if (isManager) {
		return { role: 'MANAGER' };
	}
	return null;
}

export function checkPermission (allPermission, hasPermission) {
	if (allPermission?.includes(hasPermission)) {
		return true;
	}
	return false;
}
